import { RouteType } from "types/RouteType";
import { qualityControlRoutes } from "@intrasync/quality-control";

/**
 * Routes from `@intrasync/quality-control`: the QC hub (nine tabs after the NTX
 * policy hides the module's own Yard — see qualityControlTabPolicy) and the
 * inspection capture flow.
 *
 * `requiresPermission` IS OVERRIDDEN TO FALSE, and must be.
 *
 * Both of the module's routes deliberately omit the field — its own comment
 * reads "requiresPermission omitted → defaults TRUE (library policy §7)". NTX
 * has no per-route permission grants wired, so the default turns every attempt
 * to open the hub into `route not found: unauthorized`, from the sidebar, the
 * omnibar or a direct URL. The screens are unreachable, not merely ungated.
 *
 * @intrasync/yard-management and @intrasync/inventory-management both set
 * `requiresPermission: false` on their own hub routes, which is why they worked
 * on arrival and this one did not. The override brings QC in line with them.
 *
 * This is a host decision rather than a package defect: a host that HAS wired
 * QC permissions should keep the module's stricter default. So it is overridden
 * here, next to the reason, rather than patched into the package.
 *
 * The cast bridges the package's structurally compatible route type to the
 * host's, the same way the designer and yard-management routes do.
 */
const qualityControlRoutesList: RouteType[] = (
  qualityControlRoutes as unknown as RouteType[]
).map((route) => ({
  ...route,
  requiresPermission: false,
  // The capture route's path carries required params
  // (/qc/inspection/:productRef/:stageSlug), so it cannot be opened from a menu
  // entry or the omnibar — it is only ever reached from the hub's queue. Listing
  // it just offers a click that lands nowhere useful.
  ...(String(route.path ?? "").includes(":") ? { hidden: true } : {}),
}));

export default qualityControlRoutesList;
